import axiosInstance from "./axios";
import { ChangePasswordModel } from "./models/password.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const changePassword = async (
  bearerToken: string,
  payload: ChangePasswordModel
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Users/changepassword`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to change password:", error);
    throw error;
  }
};

export const validateToken = async (
  userId: number,
  token: string
): Promise<{ valid: boolean; newLinkSent: boolean }> => {
  try {
    await axiosInstance.get(`${apiUrl}/Users/changepassword`, {
      params: {
        userId: userId,
        token: token,
      },
    });
    return { valid: true, newLinkSent: false };
  } catch (error: any) {
    if (error?.response?.status === 498) {
      error.handled = true; // Mark as handled so interceptor can check this
      return { valid: false, newLinkSent: true };
    }
    return { valid: false, newLinkSent: false };
  }
};

export const forgottonPasswordRequest = async (email: string): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Users/forgottenpassword`,
      { email }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to request forgotten password:", error);
    throw error;
  }
};
